import BqnContext from "common/BqnContext";
import { useContext, useEffect } from "react";
import { useNavigate} from 'react-router-dom';
import Dashboard from "./index";

export function DashboardSwitch() {
  const bqnContext = useContext(BqnContext);
  const bqnId = bqnContext.bqnId;
  const navigate = useNavigate();

  useEffect(() => {
    if (bqnId === "all") {
      navigate("/viewClusterDashboard");
    }
  }, [bqnId]);

  if (bqnId !== "all") {
    return <Dashboard />;
  } else {
    return null;
  }
}
